module.exports = __webpack_public_path__ + "static/media/26.394379a.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/26.wav
// module id = 5H3Z
// module chunks = 0